import { Phone } from "lucide-react";
import { CallLink } from "./CallLink";

export function Footer() {
  return (
    <footer className="bg-[var(--brand-deep)] text-primary-foreground">
      <div className="mx-auto max-w-6xl px-4 pt-12 pb-28">
        <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-center">
          <div>
            <div className="flex items-baseline gap-1.5 text-2xl font-black">
              <span>TATA</span>
              <span className="text-accent">PLAY</span>
            </div>
            <p className="mt-2 max-w-md text-sm text-white/70">
              Authorised partner for new Tata Play DTH connections and switch-over offers across India.
            </p>
          </div>
          <CallLink
            location="footer"
            label="Footer Call Now"
            className="inline-flex items-center gap-2 rounded-full bg-accent px-6 py-3 font-semibold text-accent-foreground shadow-[var(--shadow-glow)] transition hover:brightness-110"
          >
            <Phone className="h-4 w-4" /> Call Now: 6364894003
          </CallLink>
        </div>
        <div className="mt-8 border-t border-white/10 pt-6 text-xs text-white/60">
          © {new Date().getFullYear()} Tata Play DTH connections. All trademarks belong to their respective owners.
        </div>
      </div>
    </footer>
  );
}
